import { render, staticRenderFns } from "./PositionsSelect.vue?vue&type=template&id=dc68887a&scoped=true"
import script from "./PositionsSelect.vue?vue&type=script&lang=js"
export * from "./PositionsSelect.vue?vue&type=script&lang=js"
import style0 from "./PositionsSelect.vue?vue&type=style&index=0&id=dc68887a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc68887a",
  null
  
)

export default component.exports